import React, { ReactNode } from 'react';

import styled from 'styled-components';

type Props = {
  visible: boolean;
  duration?: number;
  children: ReactNode;
};

const Container = styled.div<{ $visible: boolean; $duration: number }>`
  display: grid;
  grid-template-rows: ${({ $visible }) => ($visible ? '1fr' : '0fr')};
  transition: grid-template-rows ${({ $duration }) => $duration}ms ease-out;
`;

const Inner = styled.div`
  overflow: hidden;
`;

export const Collapsible = ({ visible, duration = 200, children }: Props) => {
  return (
    <Container $visible={visible} $duration={duration}>
      <Inner>{children}</Inner>
    </Container>
  );
};
